"use client"

import { GetFootersQuery } from "@/apollo/generated/graphql"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import Link from "next/link"
import { extractMenuProperties, getNonUmbracoUrl } from "utils"
import { Desktop, Mobile } from "../../common/bit/MediaQueries"
import { colors, mediaQueries, sizes } from "../../theme/theme"
import FooterDesktop from "./FooterDesktop"
import FooterMobile from "./FooterMobile"

interface Props {
  data: GetFootersQuery
}
const StyledFooterContainer = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top-left-radius: ${sizes.borderRadius};
  border-top-right-radius: ${sizes.borderRadius};
  z-index: 4;
  position: relative;
  background-color: ${colors.white};
  margin-top: -60px;
`

const StyledRedStrip = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${colors.red};
  padding: 0 40px;

  ${mediaQueries.mobile} {
    flex-direction: column-reverse;
    justify-content: center;
    height: 118px;
    gap: 16px;
  }

  ${mediaQueries.tablet} {
    flex-direction: column-reverse;
    justify-content: center;
    height: 118px;
    gap: 16px;
  }
  ${mediaQueries.desktopM} {
    flex-direction: row;
    justify-content: space-between;
    height: 46px;
  }
`

const StyledSocialLinks = styled(Box)`
  display: flex;
  gap: 14px;
  align-items: center;
  a {
    height: 18px;
    text-decoration: none;
    color: ${colors.white};
  }
`

const Footer = ({ data }: Props) => {
  if (!data || !data?.footer_desktop || !data?.footer_mobile) return null
  return (
    <StyledFooterContainer>
      <Desktop>
        <FooterDesktop data={data} />
      </Desktop>
      <Mobile>
        <FooterMobile data={data} />
      </Mobile>
      <StyledRedStrip>
        <Typography color={colors.white} variant="body1">
          {extractMenuProperties(data?.footer_desktop as any).text}
        </Typography>
        <StyledSocialLinks>
          {(
            extractMenuProperties(data?.footer_desktop as any)?.socialLinks ||
            []
          ).map((item: any, index: number) => {
            const icon = extractMenuProperties(item).icon
            return (
              <Link
                key={`social-link-${index}`}
                target={extractMenuProperties(item).url.target ?? ""}
                href={getNonUmbracoUrl(extractMenuProperties(item).url.url)}
                prefetch={false}
              >
                {extractMenuProperties(item)?.url?.name ? (
                  <Typography variant="body1" color={colors.white}>
                    {"\u202A" + extractMenuProperties(item).url.name + "\u202C"}
                  </Typography>
                ) : (
                  <Image
                    width={18}
                    height={18}
                    src={icon}
                    alt={
                      extractMenuProperties(item).url.name ||
                      "Social media link"
                    }
                  />
                )}
              </Link>
            )
          })}
        </StyledSocialLinks>
      </StyledRedStrip>
    </StyledFooterContainer>
  )
}

export default Footer
